import { render, staticRenderFns } from "./Kodate.vue?vue&type=template&id=564a0f3b&scoped=true&"
import script from "./Kodate.vue?vue&type=script&lang=js&"
export * from "./Kodate.vue?vue&type=script&lang=js&"
import style0 from "./Kodate.vue?vue&type=style&index=0&id=564a0f3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564a0f3b",
  null
  
)

export default component.exports